<div class="loader-blur-bg">
  <div class="blur-layer"></div>
  <div class="loader-wrapper">
    <div class="whatsapp-loader">
      <div class="circle"></div>
      <div class="circle"></div>
      <div class="circle"></div>
    </div>
    <p class="verifying-text">Verifying access...</p>
  </div>
</div>
